import { FC, useState } from 'react'
import classes from './index.module.css'
import useIsTechSupport from './useIsTechSupport'
import { useChatContext } from '../ChatContext'
import { chatApi } from '@/api'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'

interface SupportChatButtonProps {
  className?: string
}

const SupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="1.7"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={classes.supportChatButtonIcon}
  >
    <path d="M4 12a8 8 0 0 1 16 0" />
    <path d="M4 12v3a2 2 0 0 0 2 2h1v-7H6a2 2 0 0 0-2 2Z" />
    <path d="M20 12v3a2 2 0 0 1-2 2h-1v-7h1a2 2 0 0 1 2 2Z" />
    <path d="M17 17v1a2 2 0 0 1-2 2h-2" />
    <path d="M11 20h2" />
  </svg>
)

const SupportChatButton: FC<SupportChatButtonProps> = ({ className }) => {
  const {
    isTechSupport,
    technicalSupportIsEnabled,
    isTechnicalSupportFloatingIconDisabled,
  } = useIsTechSupport()
  const chatContext = useChatContext()
  const [isCreating, setIsCreating] = useState(false)

  const userId = useSelector(selectProfile)?.id
  


  const handleClick = async () => {
    if (!chatContext || !userId || isCreating) {
      return
    }

    setIsCreating(true)

    try {
      const response = await chatApi.createSupportChat({ user_id: userId })

      if (response.data?.data?.chat_id) {
        chatContext.changePage('inChat', response.data?.data?.chat_id)
        // Сбрасываем счетчик непрочитанных сообщений при открытии чата
        chatContext?.setUnreadSupportMessagesCount(0)
      }
    } catch (error) {
      console.error('Error creating/accessing support chat:', error)
    } finally {
      setIsCreating(false)
    }
  }

  if (
    isTechSupport ||
    !technicalSupportIsEnabled ||
    isTechnicalSupportFloatingIconDisabled
  ) {
    return null
  }

  if (!userId) {
    return null
  }

  return (
    <div
      className={`${classes.supportChatButton}${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      style={{
        opacity: isCreating ? 0.6 : 1,
        cursor: isCreating ? 'wait' : 'pointer',
      }}
    >
      <div className={classes.iconWrapper}>
        <SupportIcon />
        {chatContext && chatContext.unreadSupportMessagesCount > 0 && (
          <div className={classes.unreadBadge}>
            {chatContext.unreadSupportMessagesCount}
          </div>
        )}
      </div>
      {/* <p className={classes.supportChatButtonText}>{`тех. \nподдержка`}</p> */}
    </div>
  )
}

export default SupportChatButton
